import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IS_DIALIFY } from '../config/siteVariant';

interface Metadata {
  title: string;
  description: string;
}

const DIALIFY_DEFAULT: Metadata = {
  title: 'Dialify — Premium Smart Watch Faces & Widgets',
  description:
    'Discover premium Smart Watch faces, widgets and curated collections with Dialify. Give every glance a style that feels personal.',
};

const DIALIFY_FUNNEL: Metadata = {
  title: 'Find Your Perfect Smart Watch Face | Dialify',
  description:
    'Take the quick Dialify style quiz and discover premium Smart Watch faces selected for your look, routine and mood.',
};

const DIALIFY_METADATA: Record<string, Metadata> = {
  '/': DIALIFY_DEFAULT,
  '/privacy': {
    title: 'Privacy Policy | Dialify',
    description: 'Learn how Dialify protects your privacy and handles information when you use our website and services.',
  },
  '/terms': {
    title: 'Terms of Use | Dialify',
    description: 'Read the terms that apply when using Dialify, its Smart Watch face collections and related services.',
  },
  '/cancellation': {
    title: 'Cancellation & Refund Policy | Dialify',
    description: 'Review the Dialify subscription cancellation and refund policy.',
  },
  '/wf/wf13': {
    title: 'Finde dein perfektes Smartwatch-Zifferblatt | Dialify',
    description:
      'Beantworte den kurzen Dialify Style-Quiz und entdecke Premium-Zifferblätter, die zu deinem Look und Alltag passen.',
  },
  '/wf/wf14': {
    title: 'Trouvez votre cadran idéal | Dialify',
    description:
      'Répondez au quiz de style Dialify et découvrez des cadrans Premium adaptés à vos envies et à votre quotidien.',
  },
};

function setMetaContent(selector: string, content: string) {
  const element = document.querySelector<HTMLMetaElement>(selector);
  if (element) element.content = content;
}

const RouteMetadata: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!IS_DIALIFY) return;

    const metadata =
      DIALIFY_METADATA[pathname] ||
      (pathname.startsWith('/wf/') ? DIALIFY_FUNNEL : DIALIFY_DEFAULT);

    document.title = metadata.title;
    setMetaContent('meta[name="description"]', metadata.description);
    setMetaContent('meta[property="og:title"]', metadata.title);
    setMetaContent('meta[property="og:description"]', metadata.description);
    setMetaContent('meta[name="twitter:title"]', metadata.title);
    setMetaContent('meta[name="twitter:description"]', metadata.description);
  }, [pathname]);

  return null;
};

export default RouteMetadata;
